import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DomainContext } from '../../domain-repository/DomainRepository'
import withLang from '../../withLang'

import DriverInfoHeader from '../../components/PageHeader'
import { FooterWithPrice } from '../../components/Footer'
import { setPageId } from '../../services/Metrics'

function QuestionPage({ history, match }) {
  const { t } = useTranslation();

  const {
    getComfortExtras,
    isCorporate,
    appFlowConfigs,
    getCorporateExtras,
    flowNextRoute,
    rentalAgreementQuoteValue,
    getUserQuestions,
    storeUserAnswer,
    flowPreviousRoute,
  } = useContext(DomainContext);

  const curIdx = Number(match.params.id) - 1;
  const questions = getUserQuestions().map(q => ({ ...q, text: t(q.key) }))
  const question = questions[curIdx];

  useEffect(() => {
    if (question) {
      setPageId({ pageId: 81 })
    }
  }, [question])

  function getNextStepUrl() {
    return flowNextRoute(match.path)
  }

  function handleNoClick() {
    storeUserAnswer({ questionID: question.id, answer: false })
    history.push(getNextStepUrl())
  }

  function handleYesClick() {
    storeUserAnswer({ questionID: question.id, answer: true })
    history.push('/baby-seats')
  }

  return (
    <div style={{ height: 'calc(100% - 87px)' }}>
      <DriverInfoHeader
        title={t('safety')}
        active={2}
        progress={'60%'}
        handleLogoClick={() => history.push('/start')}
      />
      <main className='page-layout'>
        <div className="container container-large grow">
          <div className="main-frame" style={{ height: '100%' }}>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 mb-5">
                  <h2 className="title">
                    {question.text}
                  </h2>
                </div>
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-md-6 col-8">
                      <div onClick={handleNoClick} className="btn btn-green w-100 p-3 mb-3">
                        {t('no')}
                      </div>
                    </div>
                    <div className="col-md-6 col-8">
                      <div onClick={handleYesClick} className="btn btn-green w-100 p-3 ">
                        {t('yes')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          nextHidden={true}
          handlePrevClick={() => flowPreviousRoute(history)}
        />
      </main>
    </div>
  )
}

export default withLang(QuestionPage)
